import React                          from "react"
import {Box, Button, useTheme}        from "@mui/material"
import {ArrowForward, GridViewOutlined} from "@mui/icons-material"

/*
 * The two actions on the full-screen study interstitials — the topic title screen and the
 * topic score screen (078).
 *
 * Both screens offer the same two moves, so this lives in one place rather than being copied:
 * on to the next section/topic, or out to the prepkit dashboard. There is deliberately no
 * Back — the question screen has its own navigation row for that.
 *
 * Styling mirrors the dashboard's buttons: Continue is the filled "Continue Studying"
 * treatment from the greeting header, Dashboard is the outlined treatment of the section
 * Study buttons.
 */
const StudyScreenActions = ({onContinue, onDashboard, continueLabel = 'Continue'}) => {

	const custom = useTheme().custom

	return (
		<Box sx={{display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center'}}>
			<Button
				variant="outlined"
				onClick={onDashboard}
				startIcon={<GridViewOutlined sx={{fontSize: 18}}/>}
				sx={{
					textTransform: 'none',
					borderRadius: `${custom.radius.sm}px`,
					px: 2.5,
					py: 1.25,
					fontSize: custom.fontSize.md,
					fontWeight: custom.fontWeight.semibold,
					color: custom.text.main,
					borderColor: custom.border.strong,
					'&:hover': {borderColor: custom.text.muted, background: custom.bg.dropdownHover},
				}}
			>
				Dashboard
			</Button>
			<Button
				onClick={onContinue}
				endIcon={<ArrowForward sx={{fontSize: 18}}/>}
				sx={{
					textTransform: 'none',
					borderRadius: `${custom.radius.sm}px`,
					px: 3,
					py: 1.25,
					fontSize: custom.fontSize.md,
					fontWeight: custom.fontWeight.semibold,
					background: custom.indigo.primary,
					color: '#fff',
					'&:hover': {background: custom.indigo.hover},
				}}
			>
				{continueLabel}
			</Button>
		</Box>
	)
}

export default StudyScreenActions
